const a = {
  "capacity-banner": "styles-module__capacity-banner___lxqHb"
};
export {
  a as default
};
